import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { logout } from '../utils/auth';

export interface MachineParameter {
  [key: string]: any;
}

export interface UserMachine {
  id: number;
  type: string;
  displayName: string;
  parameters: MachineParameter;
}

export interface UserMachinesResponse {
  machines: UserMachine[];
}

const queryOptions = () => ({
  queryKey: ['user-machines-list'],
  queryFn: async () => {
    const apiKey = localStorage.getItem('apiKey');
    try {
      const { data } = await axios.get<UserMachinesResponse>(
        `${process.env.REACT_APP_STUDIO_API_URL}/pwa/user-machines`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${apiKey}`,
          },
        }
      );
      return data;
    } catch (error: any) {
      if (error.response && error.response.status === 401 && error.response.data.error === "Invalid or missing API key") { 
        logout();
      } 
      throw error;
    } 
  },
}) as any;

export const useMachinesList = () => {
  return useQuery<UserMachinesResponse, Error>(queryOptions());
};

// Old hook
export const useUserMachines = () => {
  const result = useMachinesList();
  return {
    ...result,
    data: result.data ? { machineTypes: result.data.machines.map(m => m.type) } : undefined
  };
}; 